module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_6000.887e831d.png";